import { render, staticRenderFns } from "./AffaireType.vue?vue&type=template&id=9528775a&"
import script from "./AffaireType.vue?vue&type=script&lang=js&"
export * from "./AffaireType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports